// React imports.
import React, { Component } from "react";

// App imports.

import { Assessment3StepsEnum } from "../state";
import { Assessment3HHServedByVendorsProvidingDataStatusEnum } from "../state";
import { Assessment3HHVendorsSelectedStatusEnum } from "../state";
import { Assessment3RateOfReturnStatusEnum } from "../state";
import { Assessment3HHDataReceivedStatusEnum } from "../state";

//import Assessment3MainTable from "./Assessment3MainTable";
import Assessment3VendorsAssignedTable from "./Assessment3VendorsAssignedTable";
import Assessment3DataReceivedTable from "./Assessment3DataReceivedTable";
import Assessment3Sup1Table from "./Assessment3Sup1Table";
import Assessment3Sup2Table from "./Assessment3Sup2Table";
import Assessment3Sup3Table from "./Assessment3Sup3Table";
import TableLegend from "./TableLegend";

import Assessment3VendorAssignedTopParagraph from "./Assessment3VendorAssignedTopParagraph";
import Assessment3BottomText from "./Assessment3BottomText";
import Assessment3Questions from "./Assessment3Questions";
import Assessment3TopParagraph from "./Assessment3TopParagraph";
import Assessment3DataCollectedTopParagraph from "./Assessment3DataCollectedTopParagraph";
import Assessment3DropOffTable from "./Assessment3DropOffTable";
import Assessment3DownloadCSV from "./Assessment3DownloadCSV";

const Assessment3 = ({ state }) => (
      <div>
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.AssistedHouseholds &&
                <div>
                    <p>
                        <strong><u>Step 1:</u> Enter the Number of Assisted Households by Fuel Type</strong>
                    </p>
                    <p>
                        In order to establish a baseline for comparison, the first step of Assessment #3
                        is to record the number of your clients that use each type of main heating fuel
                        in the year you are evaluating. 
                    </p>
                    {state.HouseholdsAssisted.numberOfAssistedHouseholdsElectric != null
                      && <p>
                          You report the total number of LIHEAP-assisted households by fuel type in your
                          annual Performance Measures Form. Since you are evaluating a program year for which the
                          data have already been processed, we have auto-populated this information in the table below.
                      </p>}
                    {state.HouseholdsAssisted.numberOfAssistedHouseholdsElectric == null
                      && <p>
                        You report the total number of LIHEAP-assisted households by fuel type in your annual Performance
                        Measures Form. However, since you are evaluating a program year for which the data have NOT
                        already been processed, you must enter the necessary information from
                        Section V, Line A of your Performance Data Form. 
                    </p>}
                    <Assessment3VendorsAssignedTable state={state} />
                    <br />
                </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.VendorAssignment &&
                <div>
                    <p>
                        <strong><u>Step 2:</u> Number of Households Assigned to a Vendor</strong>
                    </p>
                    <p>
                        The next step of Assessment #3 is to record the number of assisted households that
                        have been assigned to a main heating fuel vendor in your database. 
                    </p>
                    <p>
                        In order to fill out your Performance Data Form Module 2, you need to collect
                        each household’s main heating fuel, the name of the vendor who supplies that heating
                        fuel, and the household’s account number. In some states, a household might only
                        apply for cooling assistance. However, you still need to collect the heating vendor
                        data for those households. Since this is a required data field, you should try to
                        collect this information from at least 95% of the households that you serve.
                    </p>
                    <p>
                        Please note that you do not report the number of assisted households that
                        have been assigned to a main heating fuel vendor in your Performance Data Form.
                        So, you will have to ask your IT staff to generate those numbers.
                    </p>

                    <Assessment3VendorsAssignedTable state={state} />
                    <br />
                </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.VendorAssignmentResults &&
                <div>
                    <p>
                        <strong><u>Step 3:</u> Vendor Assignment Results Overview</strong>
                    </p>
                    <p>
                        Now that you have provided the necessary information, we can check to
                        see if you have enough households that use each main heating fuel
                        assigned to a vendor in your database. The table below shows an
                        overview of your results. Each fuel type will be flagged for a
                        potential data reliability issue if less than 95% of households
                        are assigned to main heating fuel vendor.
                    </p>
                    <p>
                        These results are explored more thoroughly for each fuel type in Steps 3a-3d
                    </p>
                    <Assessment3VendorsAssignedTable state={state} />
                    <br />
                </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.VendorAssignmentResultsElectric &&
                <div>
                    <p>
                        <strong><u>Step 3a:</u> Vendor Assignment Results – Electric Heat Households</strong>
                    </p>
                    <p>
                        <Assessment3VendorAssignedTopParagraph fuelType={state.Assessment3FuelTypesStatus.Electric} />
                    </p>
                    <Assessment3VendorsAssignedTable state={state} />
                    <br />
                    <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.Electric} />
                    <Assessment3Questions state={state}  fuelType={state.Assessment3FuelTypesStatus.Electric} />
                </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.VendorAssignmentResultsNaturalGas &&
                <div>
                    <p>
                        <strong><u>Step 3b:</u> Vendor Assignment Results – Natural Gas Households</strong>
                    </p>
                    <p>
                        <Assessment3VendorAssignedTopParagraph fuelType={state.Assessment3FuelTypesStatus.NaturalGas} />
                    </p>
                    <Assessment3VendorsAssignedTable state={state} />
                    <br />
                    <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} />
                    <Assessment3Questions state={state}  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} />
                </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.VendorAssignmentResultsFuelOil &&
                <div>
                    <p>
                        <strong><u>Step 3c:</u> Vendor Assignment Results – Fuel Oil Households</strong>
                    </p>
                    <p>
                        <Assessment3VendorAssignedTopParagraph fuelType={state.Assessment3FuelTypesStatus.FuelOil} />
                    </p>
                    <Assessment3VendorsAssignedTable state={state} />
                    <br />
                    <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.FuelOil} />
                    <Assessment3Questions state={state}  fuelType={state.Assessment3FuelTypesStatus.FuelOil} />
                </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.VendorAssignmentResultsPropane &&
                <div>
                    <p>
                        <strong><u>Step 3c:</u> Vendor Assignment Results – Propane Households</strong>
                    </p>
                    <p>
                        <Assessment3VendorAssignedTopParagraph fuelType={state.Assessment3FuelTypesStatus.Propane} />
                    </p>
                    <Assessment3VendorsAssignedTable state={state} />
                    <br />
                    <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.Propane} />
                    <Assessment3Questions state={state}  fuelType={state.Assessment3FuelTypesStatus.Propane} />
                </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedEntry &&
                <div>
                    <p>
                        <strong><u>Step 4:</u> # of Households for Whom Data was Collected</strong>
                    </p>
                    <p>
                        The next step of Assessment #3 is to center the number of households
                        for whom complete main heating expenditure data was actually
                        received from the appropriate fuel vendor.
                    </p>
                    <p>
                        You should be collecting expenditure data from at
                        least 50% of your Electric and Natural Gas households and at
                        least 20% of your Fuel Oil and Propane households. Hitting
                        those thresholds helps ensure that you are collecting data
                        from a large enough sample to be representative of the
                        entire population of assisted households for that fuel
                        type in your state/territory.
                    </p>
                    <p>
                        Your Performance Data Form asks for the number of households for
                        whom 12 months of consecutive billing data were collected for both
                        main heating fuel and electricity. However, for the purposes of this
                        assessment we are only concerned with the number of households for
                        whom main heating fuel data was collected, so you will need to report
                        this information from your own records.
                    </p>
                    <Assessment3DataReceivedTable state={state} />
                </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedOverview &&
              <div>
                  <p>
                      <strong><u>Step 5:</u> Households with Data Collected Results - Overview </strong>
                  </p>
                  <p>
                      Now that you have provided the necessary information, we can check
                      to see if your vendors provided  data for an adequate number of
                      households. The table below shows an overview of your results.
                      Each fuel type will be flagged for a potential data reliability
                      issue if:
                  </p>
                  <ol>
                      <li>
                          You received data for less than 50% of your Electric and Natural Gas households; or
                      </li>
                      <li>
                          You received data for less than 20% of your Fuel Oil and Propane households. 
                      </li>
                  </ol>
                  <p>
                  These results are explored more thoroughly for each fuel type in Steps 6a-6d. 
                  </p>
                  <Assessment3DataReceivedTable state={state} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectric &&
              <div>
                  <p>
                      <strong><u>Step 6a:</u> Households with Data Collected – Electric Heat </strong>
                  </p>
                  <p>
                      <Assessment3DataCollectedTopParagraph fuelType={state.Assessment3FuelTypesStatus.Electric} />    
                  </p>
                  <Assessment3DataReceivedTable state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.Electric} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup1Enter &&
              <div>
                  <p>
                      <strong><u>Step 6a:</u> Households with Data Collected – Electric Heat </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.Electric} supplementalAssessmentType={1} resultFlag={false}/>
                  <Assessment3Sup1Table state={state} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup1Result &&
              <div>
                  <p>
                      <strong><u>Step 6a:</u> Households with Data Collected – Electric Heat </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.Electric} supplementalAssessmentType={1} resultFlag={true}/>
                  <Assessment3Sup1Table state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.Electric} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup2Enter &&
              <div>
                  <p>
                      <strong><u>Step 6a:</u> Households with Data Collected – Electric Heat </strong>
                  </p>
                  <p>
                      <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.Electric} supplementalAssessmentType={2} resultFlag={false}/>
                  </p>
                  <Assessment3Sup2Table state={state} />

              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup2Result &&
              <div>
                  <p>
                      <strong><u>Step 6a:</u> Households with Data Collected – Electric Heat </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.Electric} supplementalAssessmentType={2} resultFlag={true}/>
                  <Assessment3Sup2Table state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.Electric} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup3Enter &&
              <div>
                  <p>
                      <strong><u>Step 6a:</u> Households with Data Collected – Electric Heat </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.Electric} supplementalAssessmentType={3} resultFlag={false}/>
                  <Assessment3Sup3Table state={state} />

              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup3Result &&
              <div>
                  <p>
                      <strong><u>Step 6a:</u> Households with Data Collected – Electric Heat </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.Electric} supplementalAssessmentType={3} resultFlag={true}/>
                  <Assessment3Sup3Table state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.Electric} />
              </div>
          }

          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview1 &&
              <div>
                  <p>
                      <strong><u>Step 6a:</u> Households with Data Collected – Electric Heat </strong>
                  </p>
                  
                  <Assessment3DropOffTable state={state} fuelType={state.Assessment3FuelTypesStatus.Electric} step={1}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview2 &&
              <div>
                  <p>
                      <strong><u>Step 6a:</u> Households with Data Collected – Electric Heat </strong>
                  </p>

                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.Electric} step={2}  />
              </div>
          }
         {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview3 &&
              <div>
                  <p>
                      <strong><u>Step 6a:</u> Households with Data Collected – Electric Heat </strong>
                  </p>
                  
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.Electric} step={3}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview4 &&
              <div>
                  <p>
                      <strong><u>Step 6a:</u> Households with Data Collected – Electric Heat </strong>
                  </p>
                  
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.Electric} step={4}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview5 &&
              <div>
                  <p>
                      <strong><u>Step 6a:</u> Households with Data Collected – Electric Heat </strong>
                  </p>
                  
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.Electric} step={5}  />
              </div>
          }

          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGas &&
              <div>
                  <p>
                      <strong><u>Step 6b:</u> Households with Data Collected – Natural Gas </strong>
                  </p>
                  <p>
                      <Assessment3DataCollectedTopParagraph fuelType={state.Assessment3FuelTypesStatus.NaturalGas} />    
                  </p>
                  <Assessment3DataReceivedTable state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} />
              </div>
          }

          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup1Enter &&
              <div>
                  <p>
                      <strong><u>Step ba:</u> Households with Data Collected – Natural Gas </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} supplementalAssessmentType={1} resultFlag={false}/>
                  <Assessment3Sup1Table state={state} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup1Result &&
              <div>
                  <p>
                      <strong><u>Step 6b:</u> Households with Data Collected – Natural Gas </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} supplementalAssessmentType={1} resultFlag={true}/>
                  <Assessment3Sup1Table state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup2Enter &&
              <div>
                  <p>
                      <strong><u>Step 6b:</u> Households with Data Collected – Natural Gas </strong>
                  </p>
                  <p>
                      <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} supplementalAssessmentType={2} resultFlag={false}/>
                  </p>
                  <Assessment3Sup2Table state={state} />

              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup2Result &&
              <div>
                  <p>
                      <strong><u>Step 6b:</u> Households with Data Collected – Natural Gas </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} supplementalAssessmentType={2} resultFlag={true}/>
                  <Assessment3Sup2Table state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup3Enter &&
              <div>
                  <p>
                      <strong><u>Step 6b:</u> Households with Data Collected – Natural Gas </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} supplementalAssessmentType={3} resultFlag={false}/>
                  <Assessment3Sup3Table state={state} />

              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup3Result &&
              <div>
                  <p>
                      <strong><u>Step 6b:</u> Households with Data Collected – Natural Gas </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} supplementalAssessmentType={3} resultFlag={true}/>
                  <Assessment3Sup3Table state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview1 &&
              <div>
                  <p>
                      <strong><u>Step 6b:</u> Households with Data Collected – Natural Gas </strong>
                  </p>
                  
                  <Assessment3DropOffTable state={state} fuelType={state.Assessment3FuelTypesStatus.NaturalGas} step={1}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview2 &&
              <div>
                  <p>
                      <strong><u>Step 6b:</u> Households with Data Collected – Natural Gas </strong>
                  </p>

                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} step={2}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview3 &&
              <div>
                  <p>
                      <strong><u>Step 6b:</u> Households with Data Collected – Natural Gas </strong>
                  </p>
                  
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} step={3}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview4 &&
              <div>
                  <p>
                      <strong><u>Step 6b:</u> Households with Data Collected – Natural Gas </strong>
                  </p>
                  
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} step={4}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview5 &&
              <div>
                  <p>
                      <strong><u>Step 6b:</u> Households with Data Collected – Natural Gas </strong>
                  </p>
                  
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.NaturalGas} step={5}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOil &&
              <div>
                  <p>
                      <strong><u>Step 6c:</u> Households with Data Collected – Fuel Oil </strong>
                  </p>
                  <p>
                      <Assessment3DataCollectedTopParagraph fuelType={state.Assessment3FuelTypesStatus.FuelOil} />    
                  </p>
                  <Assessment3DataReceivedTable state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.FuelOil} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup1Enter &&
              <div>
                  <p>
                      <strong><u>Step 6c:</u> Households with Data Collected – Fuel Oil </strong>
                  </p>
                  <Assessment3TopParagraph
                      fuelType={state.Assessment3FuelTypesStatus.FuelOil}
                      supplementalAssessmentType={1}
                      resultFlag={false}/>
                  <Assessment3Sup1Table state={state} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup1Result &&
              <div>
                  <p>
                      <strong><u>Step 6c:</u> Households with Data Collected – Fuel Oil </strong>
                  </p>
                  <Assessment3TopParagraph
                      fuelType={state.Assessment3FuelTypesStatus.FuelOil}
                      supplementalAssessmentType={1}
                      resultFlag={true}/>
                  <Assessment3Sup1Table state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.FuelOil} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup2Enter &&
              <div>
                  <p>
                      <strong><u>Step 6c:</u> Households with Data Collected – Fuel Oil </strong>
                  </p>
                  <p>
                      <Assessment3TopParagraph
                          fuelType={state.Assessment3FuelTypesStatus.FuelOil}
                          supplementalAssessmentType={2}
                          resultFlag={false}/>
                  </p>
                  <Assessment3Sup2Table state={state} />

              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup2Result &&
              <div>
                  <p>
                      <strong><u>Step 6c:</u> Households with Data Collected – Fuel Oil </strong>
                  </p>
                  <Assessment3TopParagraph
                      fuelType={state.Assessment3FuelTypesStatus.FuelOil}
                      supplementalAssessmentType={2}
                      resultFlag={true}/>
                  <Assessment3Sup2Table state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.FuelOil} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup3Enter &&
              <div>
                  <p>
                      <strong><u>Step 6c:</u> Households with Data Collected – Fuel Oil </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.FuelOil} supplementalAssessmentType={3} resultFlag={false}/>
                  <Assessment3Sup3Table state={state} />

              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup3Result &&
              <div>
                  <p>
                      <strong><u>Step 6c:</u> Households with Data Collected – Fuel Oil </strong>
                  </p>
                  <Assessment3TopParagraph
                      fuelType={state.Assessment3FuelTypesStatus.FuelOil}
                      supplementalAssessmentType={3}
                      resultFlag={true}/>
                  <Assessment3Sup3Table state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.FuelOil} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview1 &&
              <div>
                  <p>
                      <strong><u>Step 6c:</u> Households with Data Collected – Fuel Oil </strong>
                  </p>
                  
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.FuelOil} step={1}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview2 &&
              <div>
                  <p>
                      <strong><u>Step 6c:</u> Households with Data Collected – Fuel Oil </strong>
                  </p>
                  
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.FuelOil} step={2}  />
              </div>
          }
         {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview3 &&
              <div>
                  <p>
                      <strong><u>Step 6c:</u> Households with Data Collected – Fuel Oil </strong>
                  </p>
                  
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.FuelOil} step={3}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview4 &&
              <div>
                  <p>
                      <strong><u>Step 6c:</u> Households with Data Collected – Fuel Oil </strong>
                  </p>
                  
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.FuelOil} step={4}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview5 &&
              <div>
                  <p>
                      <strong><u>Step 6c:</u> Households with Data Collected – Fuel Oil </strong>
                  </p>
                  
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.FuelOil} step={5}  />
              </div>
          }

          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropane &&
              <div>
                  <p>
                      <strong><u>Step 6d:</u> Households with Data Collected – Propane </strong>
                  </p>
                  <p>
                      <Assessment3DataCollectedTopParagraph fuelType={state.Assessment3FuelTypesStatus.Propane} />    
                  </p>
                  <Assessment3DataReceivedTable state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.Propane} />
              </div>
          }

          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup1Enter &&
              <div>
                  <p>
                      <strong><u>Step 6d:</u> Households with Data Collected – Propane </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.Propane} supplementalAssessmentType={1} resultFlag={false}/>
                  <Assessment3Sup1Table state={state} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup1Result &&
              <div>
                  <p>
                      <strong><u>Step 6d:</u> Households with Data Collected – Propane </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.Propane} supplementalAssessmentType={1} resultFlag={true}/>
                  <Assessment3Sup1Table state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.Propane} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup2Enter &&
              <div>
                  <p>
                      <strong><u>Step 6d:</u> Households with Data Collected – Propane </strong>
                  </p>
                  <p>
                      <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.Propane} supplementalAssessmentType={2} resultFlag={false}/>
                  </p>
                  <Assessment3Sup2Table state={state} />

              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup2Result &&
              <div>
                  <p>
                      <strong><u>Step 6d:</u> Households with Data Collected – Propane </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.Propane} supplementalAssessmentType={2} resultFlag={true}/>
                  <Assessment3Sup2Table state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.Propane} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup3Enter &&
              <div>
                  <p>
                      <strong><u>Step 6d:</u> Households with Data Collected – Propane </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.Propane} supplementalAssessmentType={3} resultFlag={false}/>
                  <Assessment3Sup3Table state={state} />

              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup3Result &&
              <div>
                  <p>
                      <strong><u>Step 6d:</u> Households with Data Collected – Propane </strong>
                  </p>
                  <Assessment3TopParagraph  fuelType={state.Assessment3FuelTypesStatus.Propane} supplementalAssessmentType={3} resultFlag={true}/>
                  <Assessment3Sup3Table state={state} />
                  <Assessment3BottomText state={state}  fuelType={state.Assessment3FuelTypesStatus.Propane} />
              </div>
          }

          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview1 &&
              <div>
                  <p>
                      <strong><u>Step 6d:</u> Households with Data Collected – Propane </strong>
                  </p>
                  <strong>Supplemental Investigations– Results Overview</strong>
                  <br/>
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.Propane} step={1}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview2 &&
              <div>
                  <p>
                      <strong><u>Step 6d:</u> Households with Data Collected – Propane </strong>
                  </p>
                  <strong>Supplemental Investigations– Results Overview</strong>
                  <br/>
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.Propane} step={2}  />
              </div>
          }
         {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview3 &&
              <div>
                  <p>
                      <strong><u>Step 6d:</u> Households with Data Collected – Propane </strong>
                  </p>
                  <strong>Supplemental Investigations– Results Overview</strong>
                  <br/>
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.Propane} step={3}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview4 &&
              <div>
                  <p>
                      <strong><u>Step 6d:</u> Households with Data Collected – Propane </strong>
                  </p>
                  <strong>Supplemental Investigations– Results Overview</strong>
                  <br/>
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.Propane} step={4}  />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview5 &&
              <div>
                  <p>
                      <strong><u>Step 6d:</u> Households with Data Collected – Propane </strong>
                  </p>
                  <strong>Supplemental Investigations– Results Overview</strong>
                  <br/>
                  <Assessment3DropOffTable state={state}  fuelType={state.Assessment3FuelTypesStatus.Propane} step={5}  />
              </div>
          }


          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.ActionPlanSummary &&
              <div>
                  <p>
                      <strong><u>Step 9:</u> Aggregated Action Plan </strong>
                  </p>
                  <p>
                      Congratulations! You have reached the end of Assessment #3. Your aggregated action plan for every
                      issue identified in Assessment #3 is included in the table below. You can now download or
                      print the Assessment #3 action plan below. Also, you can revisit this page at any time by
                      selecting it from the list of completed assessments on the Assessment Tool Selection Page. 
                  </p>
                  <table id="tblDataReliabilityActionPlan">
                      <thead>
                        <tr>
                            <th>Fuel</th>
                            <th>Issue</th>
                            <th>Action Plan</th>
                        </tr>
                      </thead>
                      <tbody>
                      {state.assessment3GetFuelTypesArray().map(fuel => {
                          return (
                              <React.Fragment>
                                  {(fuel.appIncludesMainHeatingTypeFlag === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>
                                        Grant Recipients should ensure
                                        that their LIHEAP application includes a section for heating fuel type.</td>
                                    <td>
                                      {fuel.appIncludesMainHeatingTypeDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.appIncludesVendorAndAcctNumFlag === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>
                                        Grant Recipients need to ensure that their
                                        client applications require clients to include their account number with their
                                        main heating vendor.</td>
                                    <td>
                                      {fuel.appIncludesVendorAndAcctNumDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.appIncludesClientWaiverFlag === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>
                                          Grant Recipients should ensure that all of their
                                          LIHEAP applicants sign a waiver</td>
                                    <td>
                                      {fuel.appIncludesClientWaiverDesc}
                                    </td>
                                  </tr>}


                                  {(fuel.anyOtherIssuesAssignmentRateFlag === false)
                                  &&
                                  <tr>
                                      <td>{fuel.description}</td>
                                      <td>
                                          Any other issues that may be impacting vendor assignment rate
                                      </td>
                                      <td>
                                          {fuel.anyOtherIssuesAssignmentRateFlag}
                                      </td>
                                  </tr>}
                                  {(fuel.householdsServedByVendorsSelectedStatus === Assessment3HHVendorsSelectedStatusEnum.NotMeetTarget)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>
                                          Either request data from {fuel.description}&nbsp;vendors that represent a greater percentage of your
                                          LIHEAP clients OR request data from a larger number of {fuel.description}&nbsp;vendors.
                                    </td>
                                    <td>
                                      {fuel.householdsServedByVendorsSelectedStatusDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.householdsServedByVendorsProvidingDataStatus === Assessment3HHServedByVendorsProvidingDataStatusEnum.NotMeetTarget)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>
                                          Either request data from a larger number of {fuel.description}&nbsp;vendors or
                                          find a way to compel the vendors from whom you originally requested data to
                                          comply with those data requests.
                                    </td>
                                    <td>
                                      {fuel.householdsServedByVendorsProvidingDataStatusDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.rateOfReturnStatus === Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>
                                          Vendors are not submitting complete data for an adequate percentage of their households. 
                                    </td>
                                    <td>
                                      {fuel.rateOfReturnStatusDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.appIncludesClientWaiverFlag === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>
                                          Vendors are including all data elements. 
                                    </td>
                                    <td>
                                      {fuel.vendorsNotIncludeAllDataElementsDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.ableToMatchAccountsFlag === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>
                                        IT staff need to be able to match main
                                        heating vendor accounts with {fuel.description} baseload or other accounts
                                    </td>
                                    <td>
                                      {fuel.ableToMatchAccountsDesc}
                                    </td>
                                  </tr>}


                                  {(fuel.displayIncreaseRateOfReturn===true)  
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>
                                        Action items to ensure that data received from an adequate number of households in the future
                                    </td>
                                    <td>
                                      {fuel.increaseNumberOfVendorsSelectedFlag == true&&
                                          <React.Fragment>
                                            Increase the number of vendors selected<br />
                                          </React.Fragment>
                                      }
                                      {fuel.increaseNumberOfVendorsProvidingFlag == true&&
                                          <React.Fragment>
                                            Increase the number of vendors providing data<br />
                                          </React.Fragment>
                                      }
                                      {fuel.increaseRateOfReturnFlag == true&&
                                          <React.Fragment>
                                            Increase the rate of return<br />
                                          </React.Fragment>
                                      }
                                      <br/>
                                      {fuel.increaseDataDesc}
                                    </td>
                                  </tr>}
                              </React.Fragment>
                          )
                      })}
                      </tbody>
                  </table>
              </div>
          }
          {(state.CurrentAssessementStepIndex != Assessment3StepsEnum.ActionPlanSummary
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview1
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview2
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview3
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview4
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview5
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview1
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview2
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview3
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview4
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview5
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview1
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview2
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview3
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview4
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview5
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview1
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview2
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview3
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview4
              && state.CurrentAssessementStepIndex != Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview5)
          &&
              <TableLegend />  
          }      
          <button className="dataButton"
              onClick={() => state.assessment3ShowPreviousStep()}>
              Previous
          </button>
          {state.CurrentAssessementStepIndex < Assessment3StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment3ShowNextStep()}
                  disabled={state.Assessment3ShowNextStepDisabled === true}>
                  Next
              </button>
          }
          {state.CurrentAssessementStepIndex < Assessment3StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment3ShowActionPlan()}
                  disabled={state.Assessment3ShowNextStepDisabled === true}>
                  View Action Plan
              </button>
          }
          <br/>
          <button className="dataButton"
              onClick={() => state.backToStart()}>
              {state.CurrentAssessementStepIndex < Assessment3StepsEnum.ActionPlanSummary
              &&<React.Fragment>Back to start</React.Fragment>}
              {state.CurrentAssessementStepIndex === Assessment3StepsEnum.ActionPlanSummary
              &&<React.Fragment>Finish &amp; Save</React.Fragment>}
          </button>

          

          {state.CurrentAssessementStepIndex === Assessment3StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => window.print()}>
                  Print
              </button>
          }
          {state.CurrentAssessementStepIndex == Assessment3StepsEnum.ActionPlanSummary
          &&
            <Assessment3DownloadCSV fuelTypes={[state.Assessment3FuelTypesStatus.Electric, state.Assessment3FuelTypesStatus.NaturalGas, , state.Assessment3FuelTypesStatus.FuelOil, state.Assessment3FuelTypesStatus.Propane]}/>
          }

          <div style={{clear:"both"}}>&nbsp;</div>
      </div>
    );

export default Assessment3;
